module.exports = __webpack_public_path__ + "static/media/law_subject_choice.2802bb43.png";